import React from "react";

import 'bootstrap/dist/css/bootstrap.min.css';
import "./App.css";
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";

import NotaCusco from "./pages/NotaCusco";
import NotaPiura from "./pages/NotaPiura";
import NotaPiuraWeb from "./pages/NotaPiuraWeb";
import NotaApurimac from "./pages/NotaApurimac";
import NotaArequipa from "./pages/NotaArequipa";
import NotaArequipaWeb from "./pages/NotaArequipaWeb";
import NotaLoreto from "./pages/NotaLoreto";
import Home from "./pages/Home";
import NotaMoquegua from "./pages/NotaMoquegua";

function App() {
    return (
        <Router basename={"especiales/transparencia-industrias-extractivas/"}>
            <div>
           
                <Switch>
                    <Route path="/pobreza-corrupcion-provincias-mineras-cusco">
                        <NotaCusco />
                    </Route>
                    <Route path="/unp-invierte-apenas-5-canon-investigacion">
                        <NotaPiura />
                    </Route>
                    <Route path="/unp-invierte-apenas-5-canon-investigacion-cutivalu">
                        <NotaPiuraWeb />
                    </Route>
                    <Route path="/deuda-corrupcion-como-herencia-municipio-abancay">
                        <NotaApurimac />
                    </Route>
                    <Route path="/cerro-verde-deficiencias-monitoreos-participativos">
                        <NotaArequipa />
                    </Route>
                    <Route path="/cerro-verde-deficiencias-monitoreos-participativos-buho">
                        <NotaArequipaWeb />
                    </Route>
                    <Route path="/loreto-migajas-para-hijos-oro-negro">
                        <NotaLoreto />
                    </Route>
                    <Route path="/santiago-pachas-pueblo-agoniza-sed">
                        <NotaMoquegua />
                    </Route>
                    <Route path="/">
                        <Home />
                    </Route>
                </Switch>
            </div>
        </Router>
    );
}

export default App;
